<template>
  <modal-base
    justify-modal-actions="center"
    @close="handleClose"
    :heading="$t('changeRoleModal.title')"
  >
    <vue-select :loading="loading" :options="options" v-model="selectedUser" />
    <help-text v-if="!loading && !options.length">
      {{ $t("changeRoleModal.helpText") }}
    </help-text>
    <template slot="buttons">
      <btn
        :loading="processing"
        :disabled="!selectedUser"
        @click="handleChangeAccount"
        >{{ $t("confirm") }} <v-icon right>mdi-account-switch</v-icon></btn
      >
    </template>
  </modal-base>
</template>

<script>
import ModalBase from "Components/Public/ModalBase.vue";
import { getAccountUsers, switchToUser } from "Adapters/ApiAdapter/account";
import userMixin from "Shared/mixins/userMixin";
import Btn from "Shared/components/Public/General/Buttons/Btn.vue";
import { appRoutes } from "Public/consts/appRoutes";
import HelpText from "Components/Public/General/Text/HelpText.vue";
import { INIT } from "Public/store";
import { accountUserToSelectOption } from "Modules/accounts/utils/accountUserToSelectOption";

export default {
  name: "RoleChangeModal",
  mixins: [userMixin],
  components: { HelpText, ModalBase, Btn },
  data() {
    return {
      options: [],
      selectedUser: undefined,
      loading: false,
      processing: false,
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    async handleChangeAccount() {
      if (!this.selectedUser) return;
      this.processing = true;
      try {
        await switchToUser(this.selectedUser.value);
        await this.$store.dispatch(INIT);
        this.handleClose();
        await this.$router.push(appRoutes.library);
      } catch {
        this.processing = false;
      }
    },
  },
  async mounted() {
    this.loading = true;
    const userAccounts = await getAccountUsers();
    const otherAccounts = userAccounts.filter(
      (user) => user.id !== this.user.id
    );
    this.options = otherAccounts.map((user) => accountUserToSelectOption(user));
    this.loading = false;
  },
};
</script>

<style lang="scss">
.modal-actions {
  justify-content: center;
}
</style>
